export function passwordMatch(newPassword, values) {
  if (values.confirmPassword !== values.newPassword)
    return "New password does not match the confirm password";
  else return "";
}
